import {NavigationHelpers} from '@react-navigation/native';
import {LocalParamList} from '../../shared/components/tabBar/components/types';
import View, {IStateProps} from './view';
import {Screens} from '../../shared/routing';
import {VisuallyImpairedForm} from '../../shared/components/visuallyImpaired/form';

import {useAppDispatch} from '../../redux';
import {changeThemeProperty} from '../../redux/actions/runtime/theme';
import {VisImpStatus} from '../../shared/models/visuallyImpairedSettings';
import {useCallback} from 'react';
import {SafeAreaView} from 'react-native-safe-area-context';

export interface Props {
  navigation: NavigationHelpers<LocalParamList>;
}

export const VisuallyImpairedSettingsLoginScreen = ({navigation}: Props) => {
  const dispatch = useAppDispatch();
  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }
    const routeNames = navigation.getState()?.routeNames ?? [];
    navigation.navigate(routeNames.includes(Screens.Login) ? Screens.Login : Screens.CardReissue);
  }, [navigation]);
  const onDefaultVersion = useCallback(() => {
    goBack();
    dispatch(changeThemeProperty('visuallyImpaired', VisImpStatus.Disabled));
  }, [goBack, dispatch]);
  const props: IStateProps = {
    onDefaultVersion,
    onGoBackClick: goBack,
  };

  return (
    <SafeAreaView edges={['top']} style={{flex: 1}}>
      {VisuallyImpairedForm<IStateProps>({
        render: View,
        props,
      })}
    </SafeAreaView>
  );
};
